import { render, staticRenderFns } from "./X-incident-modale.vue?vue&type=template&id=6570225e&scoped=true"
import script from "./X-incident-modale.vue?vue&type=script&lang=js"
export * from "./X-incident-modale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6570225e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/bitnami/deploy/oscar_front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6570225e')) {
      api.createRecord('6570225e', component.options)
    } else {
      api.reload('6570225e', component.options)
    }
    module.hot.accept("./X-incident-modale.vue?vue&type=template&id=6570225e&scoped=true", function () {
      api.rerender('6570225e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/incident/X-incident-modale.vue"
export default component.exports